import React, { useEffect, useState } from "react";
import assetsCompareServices from "./assetsCompareServices";
import adminLogo from '../../../assets/images/logo.png';
import Pagination from "../../Header/Pagination";

export default function AdminAsset() {

    let [resetVal, setResetVal] = useState(0);
    let [totalRows, setTotalRows] = useState(0);
    let [searchFor, setsearchFor] = useState("");
    var payLoad = { pageSize: 10, pageNumber: 1 }
    let [AssetType, setAssetType] = useState("tracks");
    let [selectionList, setSelectionList] = useState<any>([]);

    useEffect(() => {
        searchFor = "";
        setsearchFor(searchFor);
    }, [])

    const exportAssetData = (type: any) => {

    }

    var payload = {
        "type": AssetType,
        pageNumber: 1,
        pageSize: 10
    }
    const paginationHandler = (e: any) => {
        payLoad.pageSize = e.pageSize;
        payLoad.pageNumber = e.pageNumber;
        resetVal = 0
        setResetVal(resetVal)
        setFullAdminAssets((fullTempAdminAssets?.slice((e.pageNumber - 1) * e.pageSize, (e.pageSize * e.pageNumber))))
    }

    let [fullAdminAssets, setFullAdminAssets] = useState<any>([]);
    let [fullTempAdminAssets, setFullTempAdminAssets] = useState<any>([]);
    const searchSummary = (e: any) => {
        payload.type = AssetType;
        assetsCompareServices.portalApiListing(payload).then((res) => {
            fullTempAdminAssets = res
            setFullTempAdminAssets(fullTempAdminAssets)
            totalRows = res?.length
            setTotalRows(totalRows)
            setFullAdminAssets((fullTempAdminAssets?.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber))))
        })
    }

    const searchForSummary = (e: any) => {
        console.log(searchFor)

        if (searchFor.length > 0) {

            var obj = fullTempAdminAssets.filter((item: any) => {
                return (
                    item.catalogNumber?.toLowerCase().includes(searchFor.toLowerCase()) ||
                    item.releaseTitle?.toLowerCase().includes(searchFor.toLowerCase()) ||
                    item.releaseArtist?.toLowerCase().includes(searchFor.toLowerCase()) ||

                    item.trackArtist?.toLowerCase().includes(searchFor.toLowerCase()) ||
                    item.trackName?.toLowerCase().includes(searchFor.toLowerCase()) ||
                    item.iSRC?.toLowerCase().includes(searchFor.toLowerCase()) ||

                    item.songCode?.toLowerCase().includes(searchFor.toLowerCase()) ||
                    item.songTitle?.toLowerCase().includes(searchFor.toLowerCase()) ||
                    item.songWriters?.toLowerCase().includes(searchFor.toLowerCase())
                );
            });

            totalRows = obj?.length
            setTotalRows(totalRows)

            setFullAdminAssets(obj)
        } else {

            setFullAdminAssets((fullTempAdminAssets?.slice((payload.pageNumber - 1) * payload.pageSize, (payload.pageSize * payload.pageNumber))))
        }
    }


    const invalidData = (e: any, headerName: any) => {
        console.log(e)
        console.log(headerName)
        var invalidData = ""

        if (headerName === "Release Code") {
            if (!e?.catalogNumber && (e?.releaseTitle || e?.releaseArtist)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "Release Code") {
            if (!e?.releaseTitle && (e?.catalogNumber || e?.releaseArtist)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "Release Artist") {
            if (!e?.releaseArtist && (e?.catalogNumber || e?.releaseTitle)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "ISRC") {
            if (!e?.iSRC && (e?.trackName || e?.trackArtist)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "Track Title") {
            if (!e?.trackName && (e?.iSRC || e?.trackArtist)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "Track Artist") {
            if (!e?.trackArtist && (e?.iSRC || e?.trackName)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "ISRC") {
            if (!e?.iSWC && (e?.songTitle || e?.songWriters)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "Track Title") {
            if (!e?.songTitle && (e?.iSWC || e?.songWriters)) {
                invalidData = 'bg-level6'
            }
        }

        if (headerName === "Track Artist") {
            if (!e?.songWriters && (e?.iSWC || e?.songTitle)) {
                invalidData = 'bg-level6'
            }
        }
        return invalidData;
    }

    return (<>
        <div className="landing ws-12">

            <div className="ws-12 pLarge">
                <div className="ws-12 ptxl mtl">
                    <span className="ws-12 text-bold text-xl">Asset Management</span>
                    <span className="ws-12 ptl text-bold text-m turquoise">Portal Assets</span>
                </div>

                <div className='ws-12'>
                    <ul className="nav nav-tabs p0 m0 pull-right">
                        <li className={AssetType === "tracks" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { setResetVal(1); AssetType = "tracks"; setAssetType(AssetType); searchSummary(searchFor) }}>Tracks</li>
                        <li className={AssetType === "songs" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { setResetVal(1); AssetType = "songs"; setAssetType(AssetType); searchSummary(searchFor) }}>Songs</li>
                        <li className={AssetType === "releases" ? "m0 mt mr borderNone plxl prxl active" : "m0 mt mr plxl prxl"} onClick={() => { setResetVal(1); AssetType = "releases"; setAssetType(AssetType); searchSummary(searchFor) }}>Track Releases</li>
                    </ul>
                </div>

                <div className="ws-12 ptxl">
                    <div className="ws-12 mbl">
                        <button className="btn white pLarge bg-level14 m0 ws-2" onClick={() => searchForSummary(searchFor)}> Search</button>
                        <input type="text" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} className="pLarge ws-10 m0 heightReset" placeholder="Type to search" />
                    </div>

                </div>

                {totalRows > 0 && <div className="ws-12 bgWhite mbl">
                    <div className="ws-12 box">

                        <div className="ws-12 pm hide">

                            <div className="verticalMediumWide hover-box pull-right forceSingleLine prl">
                                <a className="white ws-12 m0 bg-level7 pm mll btn-m">Export Admin Assets </a>

                                <div className="hover-block mtlxl pt  box pm">
                                    <a className="icon-btn edit btn-xs mt ws-12" onClick={() => exportAssetData("All_A")}>Export All Assets </a>
                                    <a className="icon-btn edit btn-xs mt ws-12" onClick={() => exportAssetData("Selected_A")}>Export Selected Assets</a>
                                    <a className="icon-btn edit btn-xs mt ws-12" onClick={() => exportAssetData("All_PA")}>Export All  physical Assets</a>
                                    <a className="icon-btn edit btn-xs mt ws-12" onClick={() => exportAssetData("Selected_PA")}>Export Selected physical Assets</a>
                                </div>
                            </div>

                        </div>

                        <div className="ws-12 pm ptl pt pb">
                            <span className="text-bold text-m">Showing <span className="info">{totalRows}</span> results</span>
                        </div>

                        {<div className='ws-12 mtl pLarge tableVertical'>
                            <table className={'bgWhite table tablePresentation'}>
                                <thead>
                                    <tr>
                                        {AssetType === "releases" && <th className="text-center">Release Code</th>}
                                        {AssetType === "releases" && <th className="text-center">Release Title</th>}
                                        {AssetType === "releases" && <th className="text-center">Release Artist</th>}
                                        {AssetType === "releases" && <th className="text-center">CustomID</th>}

                                        {(AssetType === "tracks" || AssetType === "releases") && <th className="text-center">ISRC</th>}
                                        {(AssetType === "tracks" || AssetType === "releases") && <th className="text-center">Track Title</th>}
                                        {(AssetType === "tracks" || AssetType === "releases") && <th className="text-center">Track Artist</th>}

                                        {AssetType === "songs" && <th className="text-center">Song Code</th>}
                                        {AssetType === "songs" && <th className="text-center">Song Title</th>}
                                        {AssetType === "songs" && <th className="text-center">Song Writer</th>}
                                    </tr>
                                </thead>
                                <tbody>

                                    {fullAdminAssets?.map((list: any, index: any) => {
                                        return (<>
                                            <tr className={index % 2 === 0 ? 'bg-level8' : 'bg-red'}>

                                                {AssetType === "releases" && <td width='13%' className={invalidData(list, "Release Code")}>{list?.catalogNumber}</td>}
                                                {AssetType === "releases" && <td width='13%' className={invalidData(list, "Release Title")}>{list?.releaseTitle}</td>}
                                                {AssetType === "releases" && <td width='13%' className={invalidData(list, "Release Artist")}>{list?.releaseArtist}</td>}
                                                {AssetType === "releases" && <td width='13%' className={invalidData(list, "CustomID")}>{list?.customID}</td>}

                                                {(AssetType === "tracks" || AssetType === "releases") && <td width={AssetType === "releases" ? '13%' : '30%'} className={invalidData(list, "ISRC")}>{list?.iSRC}</td>}
                                                {(AssetType === "tracks" || AssetType === "releases") && <td width={AssetType === "releases" ? '13%' : '30%'} className={invalidData(list, "Track Title")}>{list?.trackName}</td>}
                                                {(AssetType === "tracks" || AssetType === "releases") && <td width={AssetType === "releases" ? '13%' : '30%'} className={invalidData(list, "Track Artist")}>{list?.trackArtist}</td>}

                                                {AssetType === "songs" && <td width='30%' className={invalidData(list, "Song Code")}>{list?.songCode}</td>}
                                                {AssetType === "songs" && <td width='30%' className={invalidData(list, "Song Title")}>{list?.songTitle}</td>}
                                                {AssetType === "songs" && <td width='30%' className={invalidData(list, "Song Writer")}>{list?.songWriters}</td>}
                                            </tr>
                                        </>)
                                    })}
                                </tbody>
                            </table>

                            <div className="clearfix ws-12 pm">
                                {(() => {
                                    if (totalRows > 10) {
                                        return <Pagination onChange={paginationHandler} totalRows={totalRows} resetVal={resetVal} />
                                    }
                                })()}
                            </div>
                        </div>}
                    </div>
                </div>}

                {totalRows === 0 && <>  <div className="alert">No results found for these criterias </div> </>}

            </div>

        </div>
    </>)
}